import React from 'react';
import { motion } from 'framer-motion';
export function Membership() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    y: -20
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="w-full min-h-screen bg-white" data-id="element-287">
      {/* Hero Section */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50 text-zinc-950" data-id="element-288">
        <div className="max-w-4xl mx-auto text-center" data-id="element-289">
          <motion.p className="text-sm tracking-[0.3em] uppercase mb-8 text-zinc-600" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-290">
            Exclusive Access
          </motion.p>
          <motion.h1 className="text-5xl md:text-7xl font-serif mb-8 leading-tight" style={{
          fontFamily: 'Playfair Display, serif'
        }} initial={{
          y: 30,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-291">
            Membership
          </motion.h1>
          <motion.p className="text-lg md:text-xl text-zinc-600 leading-relaxed max-w-2xl mx-auto" initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} data-id="element-292">
            Join an elite community dedicated to longevity, vitality, and
            cellular wellness.
          </motion.p>
        </div>
      </section>

      {/* Membership Tiers */}
      <section className="px-6 py-32 md:py-40 bg-white" data-id="element-293">
        <div className="max-w-7xl mx-auto" data-id="element-294">
          <div className="text-center mb-20" data-id="element-295">
            <p className="text-sm tracking-[0.3em] uppercase mb-6 text-zinc-600" data-id="element-296">
              Choose Your Path
            </p>
            <h2 className="text-4xl md:text-6xl font-serif text-zinc-950" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-297">
              Membership Tiers
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-298">
            {[{
            name: 'Essential',
            price: '$299',
            period: 'per month',
            features: ['Monthly NAD+ therapy session', 'Personalized wellness consultation', 'Priority booking', 'Member-only events access']
          }, {
            name: 'Elite',
            price: '$599',
            period: 'per month',
            features: ['Bi-weekly NAD+ therapy sessions', 'Comprehensive health assessment', 'Genetic testing & analysis', 'Concierge wellness support', 'Exclusive retreat invitations'],
            featured: true
          }, {
            name: 'Platinum',
            price: '$1,299',
            period: 'per month',
            features: ['Unlimited NAD+ therapy sessions', 'Full longevity protocol design', 'At-home treatment options', '24/7 medical team access', 'VIP retreat experiences', 'Personalized supplement program']
          }].map((tier, index) => <motion.div key={index} className={`p-8 border ${tier.featured ? 'border-zinc-950 bg-zinc-50' : 'border-zinc-200 bg-white'}`} initial={{
            y: 30,
            opacity: 0
          }} animate={{
            y: 0,
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2 + index * 0.1
          }} data-id="element-299">
                <h3 className="text-2xl font-serif mb-2 text-zinc-950" style={{
              fontFamily: 'Playfair Display, serif'
            }} data-id="element-300">
                  {tier.name}
                </h3>
                <div className="mb-6" data-id="element-301">
                  <span className="text-4xl font-serif text-zinc-950" data-id="element-302">
                    {tier.price}
                  </span>
                  <span className="text-zinc-600 text-sm ml-2" data-id="element-303">
                    {tier.period}
                  </span>
                </div>
                <ul className="space-y-4 mb-8" data-id="element-304">
                  {tier.features.map((feature, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-305">
                      <div className="w-1.5 h-1.5 bg-zinc-950 rounded-full mt-2 flex-shrink-0" data-id="element-306" />
                      <span className="text-zinc-600" data-id="element-307">{feature}</span>
                    </li>)}
                </ul>
                <button className={`w-full py-3 text-sm tracking-[0.2em] uppercase font-medium transition-colors ${tier.featured ? 'bg-zinc-950 text-white hover:bg-zinc-800' : 'border border-zinc-950 text-zinc-950 hover:bg-zinc-950 hover:text-white'}`} data-id="element-308">
                  Join Now
                </button>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="px-6 py-32 md:py-40 bg-zinc-50" data-id="element-309">
        <div className="max-w-5xl mx-auto" data-id="element-310">
          <div className="text-center mb-16" data-id="element-311">
            <h2 className="text-4xl md:text-5xl font-serif mb-8 text-zinc-950 leading-tight" style={{
            fontFamily: 'Playfair Display, serif'
          }} data-id="element-312">
              Member Benefits
            </h2>
            <p className="text-lg text-zinc-600 leading-relaxed max-w-3xl mx-auto" data-id="element-313">
              Experience the full spectrum of longevity medicine with exclusive
              member privileges.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-314">
            {['Priority access to new treatments', 'Complimentary wellness assessments', 'Exclusive educational workshops', 'Personalized longevity protocols', 'Member-only product launches', 'Luxury retreat experiences'].map((benefit, index) => <div key={index} className="flex items-start gap-4" data-id="element-315">
                <div className="w-1.5 h-1.5 bg-zinc-950 rounded-full mt-2.5 flex-shrink-0" data-id="element-316" />
                <p className="text-lg text-zinc-600" data-id="element-317">{benefit}</p>
              </div>)}
          </div>
        </div>
      </section>
    </motion.div>;
}